// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".dbab8073bfd6c5e03f478c8fdfcd9921.js";
};